import moment from "moment-timezone";

export const extractDateFromISODateTime = (dateTime: string): string => {
  const date1 = dateTime;
  const m = moment(date1).utcOffset(date1);
  const fmtDate = m.format("YYYY-MM-DD");
  return fmtDate;
};
